 /**
 * @file generateFrames.ts
 * @fileoverview Sprite frame generation utilities
 * 
 * This file contains utilities for generating sprite animation frames from sprite sheets.
 * Key functionality includes:
 * - Extracting individual frames from sprite sheets
 * - Creating texture arrays for animations
 * - Managing sprite sheet dimensions
 * - Frame calculation and positioning
 * - Texture generation utilities
 * 
 * The utilities provide functionality for:
 * - Sprite sheet processing
 * - Animation frame extraction
 * - Texture array creation
 * - Frame dimension calculations
 * - Position mapping
 * - Texture generation
 * - Animation setup
 * 
 * @module generateFrames
 */

import * as PIXI from "pixi.js";
// import { BaseTexture, Rectangle  } from '@pixi/core';

/** Counter to track sprite IDs */
let spriteId = 0;

/**
 * Creates an array of texture frames from a sprite sheet for animation
 * @param cols - Number of columns in the sprite sheet
 * @param rows - Number of rows in the sprite sheet  
 * @param totalFrames - Total number of frames to extract
 * @param sourceTexture - Source PIXI.Texture containing the sprite sheet
 * @returns Array of PIXI.Texture frames that can be used for animation
 */
export function spriteAnimCreator(
  cols: number,
  rows: number, 
  totalFrames: number,
  sourceTexture: PIXI.Texture
): PIXI.Texture[] {
  spriteId++;

  let textureFrames: PIXI.Texture[] = [];
  let baseTexture = sourceTexture.source;

  // Calculate dimensions of each frame
  const frameWidth = baseTexture.width / cols;
  const frameHeight = baseTexture.height / rows;

  let index = 0;

  // Extract individual frames from the sprite sheet
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      if (index >= totalFrames) break;

      // Calculate position of current frame
      const x = col * frameWidth;
      const y = row * frameHeight;

      // Create new texture for current frame
      const texture = new PIXI.Texture({ 
        source:baseTexture,
        frame:new PIXI.Rectangle(x, y, frameWidth, frameHeight)
      } 
      );

      textureFrames.push(texture);
      index++;
    }
  }

  return textureFrames;
}


